module.exports = __webpack_public_path__ + "static/media/jump.239274ae.jpg";